import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "./localStorage.service";
import { BehaviorSubject, tap, throwError } from "rxjs";
import { ToasterComponent } from "@coreui/angular";
import { AppToastSimpleComponent } from "../../components/toast-simple/toast.component";
//import { LocalStorageService } from "./localStorage.service";

@Injectable({
    providedIn: 'root'
})
export class MainService {
    private toasterBehaviorSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
    phoneMask: string = "00 00 00 00 00";
    tvaTax : number = 0;
    defaultErrorMessage = "Une erreur est survenue pendant l'opération. Veuillez réessayer";

    constructor(private router: Router, private localStorageService: LocalStorageService){}

    setToaster(value: any){
        this.toasterBehaviorSubject$.next(value);
    }

    getToaster(){
        let toasterInstance;
        this.toasterBehaviorSubject$.pipe(
            tap(toaster => {
                toasterInstance = toaster;
            })
        ).subscribe();

        return toasterInstance;
    }

    addToast(toastType: string, message: string, title?:string) {
          if(toastType === 'danger')  title = "Oops!";
          if(toastType === 'success') title = "Succès";

          let toasterInstance : any = this.getToaster();
          if(!(toasterInstance instanceof ToasterComponent)){
            return;
          }
          const props = {
                autohide: true,
                fade: true,
                color: toastType,
                title: title,
                message: message,
                visible: true
            };
      
            /*const componentRef = */ toasterInstance.addToast(AppToastSimpleComponent, props, {});
    
        }

    completeToaster(){
        this.toasterBehaviorSubject$.complete();
    }

    toastError(message = this.defaultErrorMessage){
        this.addToast('danger', message);
    }

    toastSuccess(message: string){
        this.addToast('success', message);
    }

    toastInfo(title: string, message: string){
        this.addToast('info', message, title);
    }


    public handleError(response: HttpErrorResponse){

        if(response.error instanceof ErrorEvent){
            console.error('An error occurred:', response.error.message);
        }
        else {
            console.error(`Backend returned code ${response.status}, body was: ${response.error}`);
            if (response.status === HttpStatusCode.Forbidden) {
                console.error('Forbidden error');
                this.localStorageService.removeItem('entreprise');
                this.localStorageService.setItem('expired_token', true);
                this.router.navigate(['/login']);
              }
        }
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}